export const obavijest_vrtic= {
    templateId: 239.2,
    category: 4,
    templateTitle: 'Obavijest poslodavcu o promjeni troška redovne skrbi djeteta u ustanovi predškolskog odgoja odnosno o prestanku postojanju osnove za naknadu troška',
    templateDescription: `<p>U slučaju promjene troška redovne skrbi djece radnika u ustanovama predškolskog odgoja ili prestanka postojanja troška po toj osnovi, radnik je obvezan o navedenome obavijestiti poslodavca.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Neoporezivim primicima smatraju se troškovi redovne skrbi djece radnika u ustanovama predškolskog odgoja.</p>
    <p>Primjerak Odluke kojom se poslodavac obvezuje na isplatu takve naknade možete vidjeti <a class="local-link" href="/contract?template=239">ovdje</a>, zajedno s pripadajućim opisom dokumenta.</p>
    <p>U slučaju promjene troška redovne skrbi djeteta radnika ili prestanka postojanja troška po toj osnovi, radnik je obvezan o navedenome obavijestiti poslodavca, a prema primjerku obavijesti u nastavku. </p>
    <p>Osim toga, radnik kojemu poslodavac isplaćuje naknadu za trošak redovne skrbi djece obavezan je poslodavcu prije isplate dostaviti izjavu da nitko drugi već ne koristi pravo na naknadu ovog troška te kopiju računa odnosno da li su navedeni primici već isplaćeni za isto razdoblje od strane drugog poslodavca, te se neoporezivo može isplatiti samo do visine stvarnih izdataka, tom smislu i izrađen primjerak izjave <a class="local-link" href="/contract?template=239">ovdje</a>.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak.</p>
  `,
  sides: [
    {
      signature: "Radnik:",
      inputs:[{ 
        type: "input", 
        required: true, 
        placeholder: "Ime i prezime",
        label: "Ime i prezime",
        inSignature: true,
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Ulica i kućni broj",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "Mjesto",
      },
      { 
        type: "input", 
        required: true, 
        placeholder: "OIB",
      },
      ],
      suffix: " (u daljnjem tekstu: Radnik),"
    }
    ],
    headline: "dajem sljedeću",
    title: "OBAVIJEST",
  
    noArticleNumbers: true,
  
    articles: [

      {
        title: '',
        mandatory: false,
        dummy: true,
        statements: [
            {
                type: 'choice',
                mandatory: true,
                choices: [
                    {
                        parts: [
                          { type: "text", content: "kojom ja, gore navedeni, u vezi s pravom na naknadu troškova smještaja koje ostvarujem kod poslodavca" },
                          { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
                          { type: "text", content: "," },
                          { type: "input",  required: true, placeholder: "Unesite adresu poslodavca" },
                          { type: "text", content: ", OIB:" },
                          { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
                          { type: "text", content: ", obavješćujem Poslodavca da počevši od" },
                          { type: "input",  required: true, placeholder: "Unesite datum." },  
                          { type: "text", content: "godine, došlo do promjena troška redovne skrbi djeteta" },  
                          { type: "input",  required: true, placeholder: "Unesite ime i prezime djeteta," },
                          { type: "text", content: "za koje ostvarujem naknadu troškova redovne skrbi u ustanovama predškolskog odgoja te da isti sada iznosi" },
                          { type: "input",  required: true, placeholder: "Unesite iznos." },                      ]
                      },
                    {
                        parts: [
                          { type: "text", content: "kojom ja, gore navedeni, u vezi s pravom na naknadu troškova smještaja koje ostvarujem kod poslodavca" },
                          { type: "input",  required: true, placeholder: "Unesite naziv poslodavca" },
                          { type: "text", content: "," },
                          { type: "input",  required: true, placeholder: "Unesite adresu poslodavca" },
                          { type: "text", content: ", OIB:" },
                          { type: "input",  required: true, placeholder: "Unesite OIB poslodavca" },
                          { type: "text", content: ", obavješćujem Poslodavca da počevši od" },
                          { type: "input",  required: true, placeholder: "Unesite datum." }, 
                          { type: "text", content: "godine, za dijete" }, 
                          { type: "input",  required: true, placeholder: "Unesite ime i prezime djeteta," },
                          { type: "text", content: "za koje ostvarujem naknadu troškova redovne skrbi u ustanovama predškolskog odgoja, više ne postoji trošak po osnovi redovne skrbi u ustanovama predškolskog odgoja." },
                          ]
  }],
  value: '',
  }
  ]
  },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures   
      statements: [],
    },
    {
      static: true,
      mandatory: true,
      editable: true,
      type: 4, 
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "\r\nPoslodavac svojim potpisom potvrđuje primitak Obavijesti dana ________________ godine.\r\n\r\nZa Poslodavca: ________________________. "
          },
        ],
      },
  ],
  };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/239.2_obavijest_vrtic.ts